<div>
<scu-title-header>{{ 'child-option.description' | translate }}</scu-title-header>
  <label class="text-16 mb-7 lh-15">
    {{ 'child-option.text' | translate }}
  </label>

  <scu-radio-button-list
    class="border-list sos-style d-block focus-behavior"
    [control]="assistanceType"
    [items]="assistanceTypes"
    [wrapperClasses]="'flex-value'"
    [dataTest]="dataTestId">
    <ng-template #itemFormat let-type let-inputID="id">
      <p class="text-18 mt-3">{{ 'child-option.' + type | lowercase | translate }}</p>
    </ng-template>
  </scu-radio-button-list>
</div>
